module.exports = __webpack_public_path__ + "static/media/arrow-top-right-with-circle.0755c700.svg";